import { getPaymentProcessorURL, redirectByResponse, AddAcceptJsTag, US_PATTERNS, fcbhCredentials, getAuthNetClientConfigURL, formatMoney } from "../util/payment";
import { getFormCampaign, postWithCredentials, fetchWithCredentials } from "../util/helpers";
import { submitAbandonedCartForm } from "../util/hubspot/forms";
import Cleave from 'cleave.js';
import "cleave.js/dist/addons/cleave-phone.us";
import first from 'lodash/first';
import last from 'lodash/last';
import isNil from 'lodash/isNil';

FCBH.docReady(() => {
  //add the accept.js tag to the head
  AddAcceptJsTag();
  FCBH.saveToStorage(FCBH.GIVE_FORM, formCampaign);
  FCBH.deleteFromStorage(formCampaign.localForm);

  // Guard each Cleave binding individually — a single missing/renamed element
  // shouldn't throw and abort the rest of this callback (initCampaign() included).
  if (document.getElementById("gospel-runners-cc-number")) {
    new Cleave('#gospel-runners-cc-number', {
      creditCard: true
    });
  }
  if (document.getElementById("gospel-runners-cc-expiration")) {
    new Cleave('#gospel-runners-cc-expiration', {
      date: true,
      datePattern: ['m', 'y']
    });
  }
  // The phone input has no id/name in the exported markup, so it can't be
  // targeted by a "#id" selector — bind Cleave directly to the element instead.
  if (step1Phone) {
    new Cleave(step1Phone, {
      phone: true,
      phoneRegionCode: 'us'
    });
  }

  initCampaign();
});

const program = {
  outreach: "FCBH",
  project_fund_code: "Vision2033-Q", // TODO: confirm the real Authorize.Net fund code for Gospel Runners with the team
  project_title: "Vision 2033",
};

const formCampaign = getFormCampaign(FCBH.GIVE_FORM);

const overlay = document.querySelector(".plans-overlay");
const step1 = document.querySelector(".plans-overlay_step-1");
const step2 = document.querySelector(".plans-overlay_step-2");
const currencyInput = document.getElementById("custom-amount");
const continueBtn = document.querySelector(".btn-lg-fill_alt-continue");
const guard = document.getElementById('continue-guard');
const backBtn = document.querySelector(".plans-modal_footer.is-back");
const stayUpdatedCheckbox = document.getElementById("stayUpdated");
// Step 1 has no form id in the exported markup — it's only addressable by name/class.
const form1 = document.querySelector('form[name="gospel-runners-step-1"]');
const step1FirstName = form1?.querySelector('input[name="gospel-runners-first-name"]');
const step1LastName = form1?.querySelector('input[name="gospel-runners-last-name"]');
const step1Email = form1?.querySelector('input[name="gospel-runners-email"]');
// The phone input is missing its "name" attribute in the exported markup, so
// it has to be targeted by type instead — flagged for the team to fix in Webflow.
const step1Phone = form1?.querySelector('input[type="tel"]');
const form2 = document.getElementById("wf-form-gospel-runners-step-2");
const donateBtn = form2.querySelector("input[type='submit']");
const donateReCaptcha = form2.querySelector(".g-recaptcha");
if (donateReCaptcha) donateReCaptcha.id = "gospel-runners-recaptcha";

const statusLabel = document.createElement("p");
statusLabel.name = "Give-Status";
statusLabel.id = "Give-Status";
statusLabel.classList.add("txt-subtitle");
statusLabel.style.display = "none";
statusLabel.innerText = "Processing your donation...";
donateBtn.parentElement.parentElement.appendChild(statusLabel);
let initialDonateBtnText = donateBtn.value;
let cardDataInfo = {};

const outreach = program.outreach;
const project_title = program.project_title;
const project_fund_code = program.project_fund_code;

let minUsdAmount = null;
let authData = {
  clientKey: null,
  apiLoginID: null,
  apiKey: null
};

async function loadAuthData() {
  var apiKey = await fcbhCredentials();
  let config;
  try {
    config = await fetchWithCredentials(getAuthNetClientConfigURL(), apiKey);
  } catch (e) {
    console.error("Error fetching AuthNet config, using default keys", e);
    config = { data: { authNetApiLoginId: getPaymentProcessorURL("apiLoginID"), authNetClientId: getPaymentProcessorURL("clientKey"), minAmount: 5 } };
  }
  let { authNetApiLoginId, authNetClientId, minAmount } = config?.data;
  authData.clientKey = authNetClientId;
  authData.apiLoginID = authNetApiLoginId;
  authData.apiKey = apiKey;
  minUsdAmount = minAmount;
}

async function initCampaign() {
  await loadAuthData();
  processCards();
  processRadioCards();
  processCustomAmount();
  processStayUpdated();
  processContinueButton();
  processModalClose();
  processExternalTriggers();
  processBackButton();

  form2.addEventListener("submit", afterFormValidate);
  form2.querySelectorAll("input[type='submit']").forEach((button) => {
    button.addEventListener("click", onFormSubmit);
  });
  

  guard.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!form1.checkValidity()) {
      form1.reportValidity();
    } else if (!isAmountValid()) {
      getRadios()[0].reportValidity();
    }
  });
  
  form1.addEventListener('blur', function (e) {
    if (e.target.matches('input, select, textarea') && !e.target.checkValidity()) {
      e.target.reportValidity();
    }
  }, true);
  form1.addEventListener('input', toggleContinueButton);
  form1.addEventListener('change', toggleContinueButton);

  window.addEventListener("pagehide", fireAbandonedCartEmailIfPending);
}

function processBackButton() {
  // Going back to step 1 is not a "close" — it must not reset the journey
  // or fire the abandoned-cart email (only the X button / page exit do).
  backBtn?.addEventListener("click", () => {
    toggleContinueButton();
    showStep("step-1");
  });
}

function saveFormInStorage(key, value) {
  const currentForm = FCBH.getFromStorage(formCampaign.localForm) || {};

  const newForm = {
    ...currentForm,
    campaign: formCampaign.campaign,
    [key]: value
  };
  FCBH.saveToStorage(formCampaign.localForm, newForm);
}

function openModal(step) {
  overlay.style.setProperty("visibility", "visible", "important");
  if (step === "step-1") {
    toggleContinueButton();
  }
  showStep(step);
}

function showStep(step) {
  if (step === "step-2") {
    step1.style.setProperty("visibility", "hidden", "important");
    step2.style.setProperty("visibility", "visible", "important");
  } else {
    step2.style.setProperty("visibility", "hidden", "important");
    step1.style.setProperty("visibility", "visible", "important");
  }
}

function closeModal() {
  overlay.style.setProperty("visibility", "hidden", "important");
  step1.style.removeProperty("visibility");
  step2.style.removeProperty("visibility");
  resetInteraction();
}

function resetInteraction() {
  document.querySelectorAll('input[name="amount-selection"]').forEach((radio) => (radio.checked = false));
  if (currencyInput) currencyInput.value = "";
  pendingHubspotCapture = null;
  toggleContinueButton();
}

function processModalClose() {
  // Both close controls just consume any pending hubspot capture; the guard
  // inside fireAbandonedCartEmailIfPending() makes this a no-op unless the
  // user actually reached step 2 with the opt-in checked.
  document.querySelector(".plans-overlay_close")?.addEventListener("click", () => {
    fireAbandonedCartEmailIfPending();
    closeModal();
  });
  document.querySelector(".plans-modal_close")?.addEventListener("click", () => {
    fireAbandonedCartEmailIfPending();
    closeModal();
  });
}

function processExternalTriggers() {
  document.querySelectorAll("#hero-trigger, #footer-trigger").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      resetInteraction();
      openModal("step-1");
    });
  });

  document.getElementById("plan-custom")?.addEventListener("click", (event) => {
    event.preventDefault();
    document.querySelectorAll('input[name="amount-selection"]').forEach((radio) => (radio.checked = false));
    toggleContinueButton();
    openModal("step-1");
    if (currencyInput) {
      currencyInput.value = 10;
      let amount = currencyInput.value;
      saveFormInStorage("amounts", {
        value: amount,
        usdValue: amount,
      });
      currencyInput.focus();
    }
  });
}

// The radio-card `value` attributes are opaque tokens ("radio-1".."radio-4"),
// not dollar amounts — the amount only exists as text next to the input
// (e.g. "$40"). Read it from there so this stays correct regardless of order.
function getRadioCardAmount(radio) {
  const label = radio.closest(".radio-card");
  if (!label) return null;
  const amountEl = Array.from(label.querySelectorAll("div")).find(
    (div) => !div.classList.contains("plans-modal_month")
  );
  return amountEl ? amountEl.textContent.replace(/[^0-9.]/g, "") : null;
}

function selectAmountRadio(amount) {
  document.querySelectorAll('input[name="amount-selection"]').forEach((radio) => {
    radio.checked = getRadioCardAmount(radio) === amount;
  });
}

function processCards() {
  document.querySelectorAll(".gospel-run_card a.btn-lg-fill_alt.is-light").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const amount = link.textContent.replace(/GIVE\s*\$/i, "").trim().replaceAll(",", "");
      saveFormInStorage("amounts", {
        value: amount,
        usdValue: amount,
      });

      selectAmountRadio(amount);
      if (currencyInput) currencyInput.value = "";
      toggleContinueButton();

      openModal("step-1");
    });
  });
}

function processRadioCards() {
  document.querySelectorAll('input[name="amount-selection"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      if (!radio.checked) return;
      const amount = getRadioCardAmount(radio);
      if (!amount) return;
      saveFormInStorage("amounts", {
        value: amount,
        usdValue: amount,
      });
      if (currencyInput && currencyInput.value) currencyInput.value = "";
      toggleContinueButton();
    });
    radio.addEventListener("click", toggleContinueButton);
  });
}

function processCustomAmount() {
  if (!currencyInput) return;
  const handleCustomInput = () => {
    const amount = currencyInput.value.replaceAll(",", "").trim();
    if (!amount) {
      toggleContinueButton();
      return;
    }
    saveFormInStorage("amounts", {
      value: amount,
      usdValue: amount,
    });
    document.querySelectorAll('input[name="amount-selection"]:checked').forEach((radio) => (radio.checked = false));
    toggleContinueButton();
  };
  
  const handleCustomInputFocus = () => {
    const amount = currencyInput.value.replaceAll(",", "").trim();
    const amounts = FCBH.getFromStorage(formCampaign.localForm)?.amounts;
    if (!amount && amounts) {
     currencyInput.value = amounts.value;
      toggleContinueButton();
      return;
    } 
    if (!amount && !amounts) {
      currencyInput.value = 10;
      amount = currencyInput.value;
    }
    saveFormInStorage("amounts", {
      value: amount,
      usdValue: amount,
    });
    document.querySelectorAll('input[name="amount-selection"]:checked').forEach((radio) => (radio.checked = false));
    toggleContinueButton();
  };
  const handleCustomInputBlur = () => {
    const amount = currencyInput.value.replaceAll(",", "").trim();
    saveFormInStorage("amounts", {
      value: amount,
      usdValue: amount,
    });
    if (!amount && !isAmountValid()) {
      toggleContinueButton();
      return;
    } 
  };
  currencyInput.addEventListener("input", handleCustomInput);
  currencyInput.addEventListener("change", handleCustomInput);
  currencyInput.addEventListener("keyup", handleCustomInput);
  currencyInput.addEventListener("focus", handleCustomInputFocus);
  currencyInput.addEventListener("blur", handleCustomInputBlur);
}
 function getRadios() {
      let amountSection = document.getElementById('amount-section');
      return amountSection.querySelectorAll('input[name="amount-selection"]');
  }

  function isAmountValid() {
    var radios = getRadios();
    var anyChecked = Array.prototype.some.call(radios, function (r) { return r.checked; });
    var customVal = customInput.value.trim();
    var customValid = customVal !== '' && !isNaN(customVal) && Number(customVal) > 0;
    var valid = anyChecked || customValid;
    if (radios[0]) {
      radios[0].setCustomValidity(valid ? '' : 'Please select an amount or enter a custom one.');
    }
    return valid;
  }

function processStayUpdated() {
  if (!stayUpdatedCheckbox) return;
  saveFormInStorage("share_email", stayUpdatedCheckbox.checked);
  stayUpdatedCheckbox.addEventListener("change", () => {
    saveFormInStorage("share_email", stayUpdatedCheckbox.checked);
  });
}

function toggleContinueButton() {
  const btn = continueBtn || document.querySelector(".btn-lg-fill_alt-continue");
  if (!btn) return false;

  const isRadioSelected = Array.from(
    document.querySelectorAll('input[name="amount-selection"]')
  ).some((radio) => radio.checked);

  const amounts = FCBH.getFromStorage(formCampaign.localForm)?.amounts; 

  const customEl = currencyInput || document.getElementById("custom-amount");
  let isCustomSelected = false;
  if (customEl && customEl.value.trim() !== "") {
    const clean = customEl.value.replaceAll(",", "").trim();
    const num = Number(clean.replace(/[^0-9.]/g, ""));
    isCustomSelected = !isNaN(num) && num > 0;
  }

  const hasAmount = amounts?.value > 0 && (isRadioSelected || isCustomSelected);

  const form = form1 || document.querySelector('form[name="gospel-runners-step-1"]');
  /*const firstName = step1FirstName || form?.querySelector('input[name="gospel-runners-first-name"]');
  const email = step1Email || form?.querySelector('input[name="gospel-runners-email"]');
  const phone = step1Phone || form?.querySelector('input[type="tel"]');

  const hasFirstName = Boolean(firstName && firstName.value.trim().length > 0);
  const hasEmail = Boolean(email && email.value.trim().length > 0);
  const hasPhone = Boolean(phone && phone.value.trim().length > 0);*/
  const isFormValid = form.checkValidity(); 

  const isComplete = Boolean(hasAmount && isAmountValid() && isFormValid);

  btn.disabled = !isComplete;
  if (!isComplete) {
    btn.setAttribute("disabled", "disabled");
    btn.style.opacity = "0.5";
    btn.style.cursor = "not-allowed";
  } else {
    btn.removeAttribute("disabled");
    btn.style.opacity = "";
    btn.style.cursor = "pointer";
  }

  if (guard) {
    guard.style.pointerEvents = isComplete ? "none" : "auto";
    btn.style.opacity = isComplete ? '' : '0.5';
  }

  return isComplete;
}
const updateContinueButtonState = toggleContinueButton;

function processContinueButton() {
  const form = form1 || document.querySelector('form[name="gospel-runners-step-1"]');
  const firstName = step1FirstName || form?.querySelector('input[name="gospel-runners-first-name"]');
  const email = step1Email || form?.querySelector('input[name="gospel-runners-email"]');
  const phone = step1Phone || form?.querySelector('input[type="tel"]');
  const custom = currencyInput || document.getElementById("custom-amount");

  [firstName, email, phone, custom].forEach((input) => {
    if (!input) return;
    input.addEventListener("input", toggleContinueButton);
    input.addEventListener("change", toggleContinueButton);
    input.addEventListener("keyup", toggleContinueButton);
    input.addEventListener("paste", () => setTimeout(toggleContinueButton, 0));
  });

  form?.addEventListener("input", toggleContinueButton);
  form?.addEventListener("change", toggleContinueButton);

  toggleContinueButton();

  continueBtn?.addEventListener("click", () => {
    if (continueBtn.disabled) return;

    const amounts = FCBH.getFromStorage(formCampaign.localForm)?.amounts;
    if (!amounts?.value) {
      showErrorWithMessage("Please choose or enter an amount to continue.");
      return;
    }
    hideErrors();

    captureHubspotDataIfOptedIn();

    document.querySelectorAll('input[name="gospel-runners-payment"]').forEach((radio) => {
      radio.checked = radio.value === "credit-card";
    });

    updateDonationSummary(amounts.value);
    openModal("step-2");
  });
}

function updateDonationSummary(amount) {
  const summaryEl = document.querySelector(".plans-overlay_step-2 .sml-bold");
  if (summaryEl) summaryEl.textContent = `$${formatMoney(String(amount).replaceAll(",", ""))}/month`;
}

// Abandoned-cart email flow (client requirement): capture name/email the
// moment they opt in and hit Continue, but only actually send it to HubSpot
// if they close out via the X button or leave the page before donating —
// never immediately, and never if they complete the donation.
let pendingHubspotCapture = null;
let hasAttemptedSubmit = false;

function captureHubspotDataIfOptedIn() {
  const email = step1Email?.value?.trim();
  if (!stayUpdatedCheckbox?.checked || !email) {
    pendingHubspotCapture = null;
    return;
  }
  pendingHubspotCapture = {
    firstName: step1FirstName?.value?.trim(),
    lastName: step1LastName?.value?.trim(),
    email,
  };
}

function fireAbandonedCartEmailIfPending() {
  if (!pendingHubspotCapture || hasAttemptedSubmit) return;
  const { firstName, lastName, email } = pendingHubspotCapture;
  pendingHubspotCapture = null;
  try {
    // sendBeacon-based — safe to call from a "pagehide" handler without awaiting.
    submitAbandonedCartForm({ firstName, lastName, email });
  } catch (err) {
    console.error(err);
  }
}

function getFormStruct() {
  const { amounts, share_email } = FCBH.getFromStorage(formCampaign.localForm) ?? {};
  const amount = amounts?.usdValue;
  const formattedDonationTotal = `$${amounts?.value}`;

  const formData = new FormData(form2);

  // Step 1 fields are read straight from their elements (not FormData) since
  // the phone input has no "name" attribute in the exported markup.
  const firstName = step1FirstName?.value?.trim();
  const lastName = step1LastName?.value?.trim();
  const email = step1Email?.value?.trim();
  const phone = step1Phone?.value;

  const formStruct = {
    cssid: "3u8kfk8rej7cvflqqkskura2nt",
    project_title,
    project_fund_code,
    undesignated_donation: "",
    amount: `$${amount}`,
    usd_amount: Math.ceil(amount),
    formatted_donation_total: formattedDonationTotal,
    currency_code: 'USD',
    outreach,
    recurring_donation: "yes",
    return_site: "fcbh",
    first_name: firstName,
    last_name: lastName,
    address_street: formData.get("gospel-runners-address"),
    address_country: "US",
    address_city: formData.get("gospel-runners-city"),
    address_state: formData.get("gospel-runners-state"),
    address_zip: formData.get("gospel-runners-zip"),
    phone: phone?.replace(/\s/g, '').slice(-10),
    email,
    card_num: formData.get("gospel-runners-cc-number"),
    card_expiration: formData.get("gospel-runners-cc-expiration"),
    card_security_code: formData.get("gospel-runners-cc-cvc"),
    name: `${firstName} ${lastName}`,
    customer_type: 'Individual',
    customer_type_value: 'I',
    campaign: formCampaign.campaign,
    share_email: !!share_email,
  };
  return formStruct;
}

function disableSubmitButton() {
  if (donateBtn) {
    donateBtn.disabled = true;
    donateBtn.style.pointerEvents = "none";
    donateBtn.value = "Processing your donation...";
  }
  if (statusLabel) {
    statusLabel.style.display = "block";
  }
}

function enableSubmitButton() {
  if (donateBtn) {
    donateBtn.disabled = false;
    donateBtn.style.pointerEvents = "auto";
    donateBtn.value = initialDonateBtnText || "Submit";
  }
  if (statusLabel) {
    statusLabel.style.display = "none";
  }
}

function onFormSubmit(event) {
  hideErrors();

  if (donateBtn && donateBtn.disabled) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  const errors = validateForm(getFormStruct());
  if (errors.length > 0) {
    showErrorWithMessage(errors);
    event.preventDefault();
    return false;
  }

  return true;
}

async function afterFormValidate(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (donateBtn && donateBtn.disabled) {
    return;
  }

  if (!onFormSubmit(event)) {
    return;
  }

  initialDonateBtnText = donateBtn?.value || "Submit";
  try {
    const cresponse = grecaptcha.getResponse();
    if (cresponse.length == 0) {
      showErrorWithMessage("Please verify that you are not a robot.");
      return;
    }
    const formStruct = getFormStruct();

    disableSubmitButton();
    // The user is now completing a transaction — stop treating a
    // subsequent close/exit as an abandoned journey.
    hasAttemptedSubmit = true;

    await processAcceptJsPayment(formStruct);

  } catch (err) {
    console.error(err);
    enableSubmitButton();
    // The attempt failed before completing a donation — a subsequent
    // close/exit is still an abandoned journey, so allow the email again.
    hasAttemptedSubmit = false;
    if (err?.status == 400 && err?.errors) {
      showErrorWithMessage(err.errors);
    } else if (err?.status == 400 && err?.data?.detailed_messages) {
      showErrorWithMessage(err.data.detailed_messages);
    } else if (err?.status == 401 || err?.status == 403) {
      showErrorWithMessage(
        "You are not authorized or your token may have expired to perform this action. Please reload the page or try again later."
      );
    } else if (err?.responseText?.includes("status")) {
      disableSubmitButton();
      const response = { data: err.responseText };
      redirectByResponse(response, { mustRedirectTo: "/gospel-runners" }, formCampaign.localForm);
    } else {
      showErrorWithMessage("An error occurred while sending the form, please try again later.");
    }
  }
}

function processAcceptJsPayment(formStruct) {
  disableSubmitButton();

  cardDataInfo.cardNumber = formStruct["card_num"].trim();
  cardDataInfo.expiration = formStruct["card_expiration"].trim();
  cardDataInfo.securityCode = formStruct["card_security_code"].trim();

  var cardData = {};
  cardData.cardNumber = formStruct["card_num"].trim().replaceAll(" ", "");
  cardData.month = first(formStruct["card_expiration"].split("/"));
  cardData.year = last(formStruct["card_expiration"].split("/"));
  cardData.cardCode = formStruct["card_security_code"];
  cardData.zip = formStruct["address_zip"];
  cardData.fullName = `${formStruct["first_name"]} ${formStruct["last_name"]}`;
  var secureData = {};
  secureData.authData = authData;
  secureData.cardData = cardData;
  replaceCardInfo(formStruct);

  try {
    Accept.dispatchData(secureData, (resp) => {
      responsesHandler(resp, formStruct);
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
}

async function responsesHandler(resp, formStruct) {
  var data = {};
  data.detailed_messages = '';
  data.response_reason_text = '';

  if (resp.messages.resultCode === "Error") {
    var i = 0;
    while (i < resp.messages.message.length) {
      data.response_reason_text += resp.messages.message[i].code;
      data.detailed_messages += resp.messages.message[i].text;
      i = i + 1;
    }
    showErrorWithMessage(data.detailed_messages);
    enableSubmitButton();
    hasAttemptedSubmit = false;
  } else {
    disableSubmitButton();
    setTimeout(async () => {
      await paymentFormUpdate(resp.opaqueData, formStruct);
    }, 7000);
  }
}

function replaceCardInfo(formStruct) {
  var cardNum = formStruct["card_num"].replace(/\s/g, "");
  document.getElementById("gospel-runners-cc-number").value = cardNum.replace(/\d(?=\d{4})/g, "*");
  document.getElementById("gospel-runners-cc-expiration").value = "";
  document.getElementById("gospel-runners-cc-cvc").value = "";
}

function returnCardInfo() {
  document.getElementById("gospel-runners-cc-number").value = cardDataInfo.cardNumber;
  document.getElementById("gospel-runners-cc-expiration").value = cardDataInfo.expiration;
  document.getElementById("gospel-runners-cc-cvc").value = cardDataInfo.securityCode;
  cleanCardInfo();
}

function cleanCardInfo() {
  cardDataInfo.cardNumber = "";
  cardDataInfo.expiration = "";
  cardDataInfo.securityCode = "";
}

async function paymentFormUpdate(opaqueData, formStruct) {
  disableSubmitButton();
  formStruct["card_num"] = "";
  formStruct["card_expiration"] = "";
  formStruct["card_security_code"] = "";

  const formToSend = new FormData();
  for (const key in formStruct) {
    formToSend.append(key, formStruct[key]);
  }
  formToSend.append('opaque_data_descriptor', opaqueData.dataDescriptor);
  formToSend.append('opaque_data_value', opaqueData.dataValue);

  try {
    authData.apiKey = await fcbhCredentials();
    const response = await postWithCredentials(
      getPaymentProcessorURL('process'),
      formToSend,
      authData.apiKey
    );
    cleanCardInfo();
    redirectByResponse(response, { mustRedirectTo: "/gospel-runners" }, formCampaign.localForm);

  } catch (err) {
    console.error(err);
    var failedStatuses = ['fail', 'decline', 'pending'];
    if (err?.status == 400 && err?.responseJSON?.data?.detailed_messages && !failedStatuses.includes(err?.responseJSON?.status)) {
      showErrorWithMessage(err.responseJSON.data.detailed_messages);
      hasAttemptedSubmit = false;
      enableSubmitButton();
    } else if (err?.status == 401 || err?.status == 403) {
      showErrorWithMessage(
        "You are not authorized or your token may have expired to perform this action. Please reload the page or try again later."
      );
      hasAttemptedSubmit = false;
      enableSubmitButton();
    } else if (err?.responseText?.includes("status")) {
      disableSubmitButton();
      const response = { data: err.responseText };
      redirectByResponse(response, { mustRedirectTo: "/gospel-runners" }, formCampaign.localForm);
    } else {
      showErrorWithMessage("An error occurred while sending the form, please try again later.");
      returnCardInfo();
      hasAttemptedSubmit = false;
      enableSubmitButton();
    }
  }
}

function validateForm(formStruct) {
  const requireds = [
    "first_name",
    "last_name",
    "address_street",
    "address_city",
    "address_state",
    "phone",
    "email",
    "card_num",
    "card_expiration",
    "card_security_code",
  ];
  const cleanNames = [
    "First Name",
    "Last Name",
    "Mailing Address",
    "City",
    "State",
    "Phone Number",
    "Email",
    "Card Number",
    "Card Expiration",
    "CVC",
  ];

  const errors = [];
  for (const key in formStruct) {
    if (requireds.includes(key) && !formStruct[key]) {
      errors.push(`${cleanNames[requireds.indexOf(key)]} is required.`);
    }
    if (key === "card_num" && formStruct[key] && !isCCValid(formStruct[key])) {
      errors.push(`Please enter a valid credit card number.`);
    }
    if (key === "card_expiration" && formStruct[key] && !isExpirationValid(formStruct[key])) {
      errors.push(`Please enter a valid expiration date.`);
    }
    if (key === "first_name" || key === "last_name") {
      const regex = /^(['À-ÿa-zA-Z\/\s])*$/;
      if (formStruct[key] && !regex.test(formStruct[key])) {
        errors.push(`${cleanNames[requireds.indexOf(key)]} can only be letters.`);
      }
    }
    if (key === "email") {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (formStruct[key] && !regex.test(formStruct[key])) {
        errors.push(`${cleanNames[requireds.indexOf(key)]} is not valid.`);
      }
    }
    if (key === "address_zip" && !isNil(formStruct[key]) && formStruct[key] !== "" && formStruct.address_country === 'US' && !US_PATTERNS.zip_code.test(formStruct[key])) {
      errors.push(`Zip Code is not valid.`);
    }
  }

  if (minUsdAmount && formStruct['usd_amount'] && formStruct['usd_amount'] < minUsdAmount) {
    errors.push(`Please enter an amount greater than USD ${minUsdAmount}`);
  }

  return errors;
}

function isCCValid(value) {
  //replace all non-numberic values
  value = value.replace(/\D/g, "");

  //check for valid length - should be between 13-19 digits
  if (value.length < 13 || value.length > 19) {
    return false;
  }

  //Pop off the last digit
  var lastDigit = value.slice(-1);

  //Get the value without the last digit
  value = value.slice(0, -1);

  //Reverse the string
  value = value.split("").reverse();

  var total = 0;
  for (let index = 0; index < value.length; ++index) {
    //Double every other digit
    if (index % 2 == 0) {
      value[index] = value[index] * 2;
    }

    //Subtract 9 from each value over 9
    if (value[index] > 9) {
      value[index] = value[index] - 9;
    }

    //Add up all the numbers
    total = Number(total) + Number(value[index]);
  }

  //Muliply the total by 9
  total = Number(total) * 9;

  //Value modulo 10 should equal the lastDigit variable if card is the correct format
  return total % 10 == lastDigit ? true : false;
}

function isExpirationValid(value) {
  //replace all non-numberic values
  value = value.replace(/\D/g, "");

  //check for valid length
  if (value.length != 4 && value.length != 6) {
    return false;
  }

  //Get the month
  var expMonth = value.slice(0, 2);

  //Get the year
  var expYear = value.slice(-2);

  //Get the current month and year
  var date = new Date();
  var currentMonth = Number(date.getMonth()) + 1;
  var currentYear = date.getFullYear().toString().slice(-2);

  //Card expires this year, and month has passed
  if (expYear == currentYear && expMonth < currentMonth) {
    return false;
  }

  //Card expired before this year
  if (expYear < currentYear) {
    return false;
  }

  //Card month is not valid
  if (expMonth < 1 || expMonth > 12) {
    return false;
  }

  //reasonably valid
  return true;
}

function showErrorWithMessage(messages) {
  const errorBlock = document.querySelector(".w-form-fail");
  let message;
  if (Array.isArray(messages)) {
    message = `Please address these errors before proceeding:<br/>${messages.join("<br/>")}`;
  } else {
    message = messages;
  }
  errorBlock.querySelector("div").innerHTML = message;
  errorBlock.style.display = "block";
  window.scrollTo(0, errorBlock.offsetTop - 150);
}

function hideErrors() {
  const errorBlock = document.querySelector(".w-form-fail");
  errorBlock.style.display = "none";
}

if (typeof FCBH !== "undefined") {
  FCBH.toggleContinueButton = toggleContinueButton;
  FCBH.updateContinueButtonState = toggleContinueButton;
}
